// import { EventBus } from './event-bus.js';
import { store } from '../store';
window.addEventListener('online', () => {
  store.commit('setIsOnline', true);
  let isUploading = store.getters.isUploading;
  if (!isUploading) {
    store.dispatch('uploadStoreEvents');
  }
});
window.addEventListener('offline', () => {
  store.commit('setIsOnline', false);
});



// WEBPACK FOOTER //
// ./src/lib/check-connection.js